import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const AiAgentsListForNRO = lazy(() =>
  import("@scenes/AgentsList").then((module) => ({
    default: module.AgentConsoleForNro,
  }))
);

export const aiAgentsNRO: NavigationRoutingObject = {
  Component: AiAgentsListForNRO,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "agent-console",
  icon: "new-nav-system-agent-management",
  tag: "new",
  heading: (t: I18nT<"dashboard-navigation">) => t("braze-ai-agents-nro-heading", "Agent Management"),
  pageNameForTracking: () => "Agent Management",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("braze-ai-agents-nro-description", "Create and manage AI agents"),
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("custom-agent", "Custom Agent"),
        t("custom-agents", "Custom Agents"),
        t("agent-console", "Agent Console"),
        t("ai-agent", "AI Agent"),
        t("ai-agents", "AI Agents"),
      ],
      description: t(
        "braze-ai-agents-nro-search-description",
        "Create and manage custom agents in the BrazeAI™ Agent Console"
      ),
    },
  ],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
};
